export const CLIENT_AGREEMENT = {
  EMPLOYEE_SALARIE_FEE: {
    IN_ARREARS: 1,
    IN_ADVANCE: 2,
  },
  AGREEMENT_TYPE: {
    UKK: 1,
    UBR: 2,
  },
  PAYMENT_DEADLINE_TYPE_OPTIONS: {
    IN_ARREARS: 1,
    IN_ADVANCE: 2,
  },
  PAYMENT_DEADLINE_OPTIONS: {
    WITHIN: {
      id: 1,
      innerText: 'dnia od wystawienia faktury',
    },
    UNTIL_DAY: {
      id: 2,
      innerText: 'następnego miesiąca',
    },
  },
};
